// extracted by mini-css-extract-plugin
export default {"b2a-parent":"BudgetToActuals_b2a-parent__bbIle","budget-inputs-parent":"BudgetToActuals_budget-inputs-parent__Wy2tC"};